import React from "react";
import notfound from "../../../Assets/NotFound/6333074.jpg";
import UseTitle from "../../Hooks/UseTitle";
const NotFound = () => {
  UseTitle("Not Found");
  return (
    <div className="py-20 bg-white">
      <div className="max-w-screen-2xl mx-auto">
        <img src={notfound} alt="" />
      </div>
    </div>
  );
};

export default NotFound;
